import { fetchDashboardBarcode, fetchDashboardQrcode } from '@apis/barcodeApis';
import { useQuery } from '@hooks/useQuery';

export const useBarcode = (d2dNo: string) => {
  return useQuery(['/dashboard/label/barcode', d2dNo], async () => fetchDashboardBarcode(d2dNo));
};

export const useQrcode = (d2dNo: string) => {
  return useQuery(['/dashboard/label/qrcode', d2dNo], async () => fetchDashboardQrcode(d2dNo));
};
